module.exports = __webpack_public_path__ + "media/admin/logo-vindi-606fb733.png";